/** 
App start
  ↓
AuthProvider renders
  ↓
useEffect runs once
  ↓
registerLogoutHandler(handler)
  ↓
────────── WAIT ──────────
  ↓
apiFetch detects auth failure
  ↓
triggerLogout()
  ↓
handler runs
*/

let onLogout: (() => void) | null = null;

export const registerLogoutHandler = (handler: () => void) => {
  onLogout = handler;
};

export const triggerLogout = () => {
  onLogout?.();
};